import {
  getApiBaseUrl,
  getAuthHeaderName,
  getAuthHeaderPrefix,
} from '@/config/api/env'
import { getAccessToken } from '@/config/api/authStore'
import { readAetherStream } from './aetherSseReader.js'

function resolveApiUrl(path) {
  const base = getApiBaseUrl()
  return base ? `${base}${path}` : path
}

function authHeaders() {
  const token = getAccessToken()
  if (!token) return {}
  return { [getAuthHeaderName()]: `${getAuthHeaderPrefix()}${token}` }
}

export async function postAetherStream({ sessionId, content, signal }) {
  const response = await fetch(resolveApiUrl('/api/chat'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ session_id: sessionId, content, file_ids: [] }),
    signal,
  })

  if (!response.ok) {
    const detail = await response.text().catch(() => '')
    return {
      ok: false,
      code: `HTTP_${response.status}`,
      message: detail || `Chat request failed with HTTP ${response.status}`,
    }
  }

  const result = await readAetherStream(response)
  if (result.error) return { ok: false, code: 'AETHER_ERROR', message: result.error }
  if (!result.text && !result.blocks?.length) {
    return { ok: false, code: 'INVALID_RESPONSE', message: 'No assistant text.' }
  }
  return {
    ok: true,
    text: result.text,
    ...(result.blocks ? { blocks: result.blocks } : {}),
    ...result.meta,
  }
}
